import { render, staticRenderFns } from "./CornerRibbon.vue?vue&type=template&id=1ce2a092&scoped=true&"
import script from "./CornerRibbon.vue?vue&type=script&lang=js&"
export * from "./CornerRibbon.vue?vue&type=script&lang=js&"
import style0 from "./CornerRibbon.vue?vue&type=style&index=0&id=1ce2a092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce2a092",
  null
  
)

export default component.exports